
import {defineComponent, onMounted} from "vue";
import EditProduct from "../components/EditProduct.vue";
import {setPageHeader} from "@/core/helpers/toolbar";
import { wmsManagesProducts } from "@/modules/wms/helpers";

export default defineComponent({
    components: {
        EditProduct
    },
    setup() {
        // same page, view-only while WMS manages products or for a product from Smart (EditProduct emits readOnly)
        const setHeader = (readOnly: boolean) => {
            const title = readOnly ? "message.VIEW message.PRODUCT" : "message.EDIT message.PRODUCT";
            setPageHeader({
                title: title,
                actionButton: null,
                breadCrumbs: [
                    { name: "message.HOME", link: "/dashboard"},
                    { name: "message.CATALOG", link: "#"},
                    { name: "message.PRODUCTS", link: "/catalog/products"},
                    { name: title,}
                ]
            });
        };
        onMounted(() => setHeader(wmsManagesProducts()));

        return {
            setHeader
        };
    }
});
